import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js'
import { IStateType } from '../../../store/models/root.interface';
import { getActiveBridgeNumbers } from '../../../store/actions/voiceLogs.action'
import { clickToCall, closeC2CModal } from '../../../store/actions/C2CModal.action';
import VoiceTemplate, { MapStateToPropsType, MapDispatchToPropsType } from '../templates/VoiceTemplate'
import {
    requestObject,
    makeSelectInProgress
} from '../../../store/Object';
import { Instances } from '../../../constants';
import { requestObjects, makeSelectObjectsArray, changeSearchStr, makeSelectInProgress as searchInProgress } from '../../../store/Objects'

const mapStateToProps = (state: IStateType) => {

    const inProgress = makeSelectInProgress(Instances.numberValidation)
    const selectData = makeSelectObjectsArray(Instances.getCallbackProfiles);
    const callbackProfileSearch = searchInProgress(Instances.getCallbackProfiles)

    return {
        C2CModal: state.C2CModal,
        C2CCall: state.C2CCall,
        bridgeNumbers: state.activeBridgeNumber,
        numberValidationInProgress: inProgress(state),
        callbackData: selectData(state),
        callbackProfileSearchInProgress: callbackProfileSearch(state),
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    getBridgeNumbers: () => dispatch(getActiveBridgeNumbers()),
    closeC2CModal: () => dispatch(closeC2CModal()),
    clickToCall: (data: any, cbS: (a: string) => void, cbE: (a: string) => void) => dispatch(clickToCall(data, cbS, cbE)),
    validateNumber: (data: any, cb: (res: any) => void) => dispatch(requestObject(Instances.numberValidation, undefined, undefined, 'POST', true, true, data, cb)),
    getCallbackProfiles: (filters?: Record<string, any>, searchTerm?: string) => dispatch(requestObjects(Instances.getCallbackProfiles, filters, { searchTerm })),
    getSearchedData: (searchStr: string) => dispatch(changeSearchStr(Instances.getCallbackProfiles, searchStr))
});

export default connect<MapStateToPropsType, MapDispatchToPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps,
)(withImmutablePropsToJS(VoiceTemplate));
